// extracted by mini-css-extract-plugin
export default {"container":"DatasetForm_container__9ms9e","field-container":"DatasetForm_field-container__u68ku","text-input":"DatasetForm_text-input__182iC","label":"DatasetForm_label__FxQp6"};